module.exports = __webpack_public_path__ + "fonts/RMU-AvusProMedium-Italic.f66383a.woff";